import { AppConfig } from "@/script/core/base/AppConfig";
import { createApp } from "vue";
import App from "./App.vue";
import { router, RouterFactory } from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import locale from "element-plus/lib/locale/lang/zh-cn";

export class AppBoot {
  public static start() {
    try {
      AppConfig.readConfig()
        .then(function (state) {
          RouterFactory.init();

          const app = createApp(App);
          app.use(store);
          app.use(router);
          app.use(ElementPlus, { locale });
          app.mount("#app");
        })
        .catch(function (error) {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  }  
}
